import{createPluginCenter as e,request as t,markdown as n}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isEncryptedData,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import o from"url";import{jsx as r,Fragment as i,jsxs as s}from"react/jsx-runtime";import l,{Suspense as c,Fragment as a,Component as d,useMemo as u,createElement as m,useState as h,useEffect as p,useCallback as f,createContext as g,useContext as w,useRef as b,Children as v,forwardRef as y,useImperativeHandle as x}from"react";import k from"@babel/runtime/helpers/defineProperty";import{useSelector as $,Model as C,createStore as E,Provider as S,useActions as D}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import P from"loadjs";export{default as loadjs}from"loadjs";import M from"query-string";import{noop as T,debounce as z,throttle as L}from"lodash";import I,{createGlobalStyle as j,StyleSheetManager as A}from"styled-components";export{createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{HelmetProvider as O}from"react-helmet-async";export{Helmet}from"react-helmet-async";import{createIntlCache as _,createIntl as N,RawIntlProvider as W}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import{toc as U}from"mdast-util-toc";import H from"remark-slug";import{all as V,toHast as q}from"mdast-util-to-hast";import{convert as B}from"unist-util-is";import F from"html-tags";import G from"react-dom";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback,useAsyncFetchMore}from"react-async-hook";window.TopWritePlugins={};class R extends HTMLElement{connectedCallback(){this.addEventListener("click",(e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=o.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}}))}}function J(e){let{component:t,defaultComponent:n=a,props:o,children:i=null}=e;return null===t?null:r(c,{fallback:null,children:r(t,{props:o,Component:n,children:i})})}customElements.define("t-attachment",R);class K extends d{constructor(){super(...arguments),k(this,"state",{hasError:!1})}componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var Q=(e,t)=>e.filter((e=>{let{descriptor:n}=e;return t===n.role})).sort(((e,t)=>{let{descriptor:{priority:n=0}}=e,{descriptor:{priority:o=0}}=t;return n-o})).map((e=>{return t=e.Component,e=>r(K,{children:r(t,{...e},"WrappedComponent")});var t}));function X(e){let{component:t,props:n}=e;return m(t,n)}function Y(e){let{props:t,role:n,component:o}=e;const i=o?r(X,{component:o,props:t}):null,s=$("components");return u((()=>Q(s,n)),[s,n]).reduce(((e,n)=>r(J,{defaultComponent:o,component:n,props:t,children:e})),i)}function Z(e){let{props:t,component:n,role:o}=e;const s=$("components"),l=u((()=>Q(s,o)),[s,o]);return r(i,{children:l.map(((e,o)=>r(J,{defaultComponent:n,component:e,props:t},o)))})}async function ee(e){let t=`topwrite-plugin-${e.name}`;if(!P.isDefined(t)){let n=`${e.host}/${e.main}`;try{await P(n,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}function te(e,t){let n;return n=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},n}const ne="localStorage";function oe(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ne;if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const re={get:()=>null,set:()=>{},del:()=>{}},ie=(e,t)=>{const n=oe(t?.persistence);return null===n?re:{get:()=>n.getItem(e),set:t=>n.setItem(e,t),del:()=>n.removeItem(e)}};function se(){const e=oe(arguments.length>0&&void 0!==arguments[0]?arguments[0]:ne);if(!e)return[];const t=[];for(let n=0;n<e.length;n+=1){const o=e.key(n);null!==o&&t.push(o)}return t}function le(){const e=$("book");if(!e)throw new Error("book object not initialized");return e}function ce(){const{config:e}=le();return e.getValue("themeConfig")}const ae="light",de="dark";function ue(e){document.documentElement.setAttribute("data-theme",e)}const me=e=>{const t=le(),n=u((()=>ie(`${e}.${t.id}.theme`)),[t.id,e]),{defaultMode:o}=ce(),[r,i]=h((()=>{const e=(e=>e===de?de:ae)(n.get()||o);return ue(e),e}));p((()=>{ue(r)}),[r]);const s=f((()=>{i(ae),n.set(ae)}),[n]),l=f((()=>{i(de),n.set(de)}),[n]);return{isDarkTheme:r===de,setLightTheme:s,setDarkTheme:l}},he=g(void 0);function pe(e){let{children:t,context:n}=e;const{isDarkTheme:o,setLightTheme:i,setDarkTheme:s}=me(n);return r(he.Provider,{value:{isDarkTheme:o,setLightTheme:i,setDarkTheme:s},children:t})}function fe(){const e=w(he);return null==e?{isDarkTheme:!1,setLightTheme:T,setDarkTheme:T}:e}function ge(){const{primaryColor:e}=ce();return r(we,{primaryColor:e})}const we=j`
  :root {
    --ttw-primary-color: ${e=>e.primaryColor};
  }

  //TODO 转移到异步加载
  //附件
  t-attachment {
    color: var(--ttw-primary-color);
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    padding: 0 4px;
    vertical-align: bottom;
    margin: 0 1px;

    &:before {
      content: '';
      width: 18px;
      height: 18px;
      background-color: var(--ttw-primary-color);
      mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
      margin-right: 4px;
    }

    &:after {
      content: "(" attr(size) ")";
      margin-left: 4px;
      display: none;
    }

    &[size]:after {
      display: inline;
    }

    &:hover {
      background: rgba(0, 0, 0, .1);
    }

    &:read-write {
      cursor: text;
    }
  }
`;const be=new class extends C{constructor(){super(...arguments),k(this,"initialState",[])}*register(e){yield this.setState((t=>t.push(e)))}};const ve=new class extends C{};var ye=Object.freeze({__proto__:null,components:be,options:ve});function xe(e,t,n){const o="function"==typeof t;o||(n=t),p((()=>{let n;const r=e();return Promise.resolve(r).then((e=>{n=e})),()=>{o&&t(n)}}),n)}function ke(e){return e.__esModule&&e.default?e.default:e}const $e=g(void 0),Ce=()=>{const e=w($e);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},Ee=e=>{let{localize:t,children:n}=e;const{addMessages:o}=Ce(),[s,l]=h(!0);return xe((async()=>{l(!0),await o(t),l(!1)}),[t]),s?null:r(i,{children:n})},Se=e=>{let{children:t}=e;const{locale:n,messages:o}=Ce(),i=u((()=>{const e=_();return N({locale:n,messages:o,defaultLocale:"en"},e)}),[n,o]);return r(W,{value:i,children:t})},De=e=>{let{children:t,locale:n,messages:o}=e;const[i,s]=h(o);return r($e.Provider,{value:{locale:n,messages:i,addMessages:async e=>{s(Object.assign({},i,ke(await e(n))))}},children:r(Se,{children:t})})};class Pe{constructor(e,t,n){k(this,"name",void 0),k(this,"book",void 0),k(this,"models",{...ye}),k(this,"components",[]),k(this,"activates",[]),k(this,"plugins",[]),k(this,"initialState",void 0),this.name=e,this.book=t,this.initialState=n}registerComponents(e,t){for(let[n,o]of Object.entries(e))o&&("plugin:setting"===n&&t&&(n=`plugin:setting:${t}`),this.components.push(te(n,o)))}registerModels(e,t){for(const[n,o]of Object.entries(e))t?this.models[`@${t}@${n}`]=o:this.models[n]=o}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e){const t=navigator.language,n=await this.loadMessages(t,e),o=E(this.models,{book:this.book,components:this.components,...this.initialState}),l=e=>{let{children:t}=e;return r(i,{children:t})},c=e=>{let{children:t}=e;const n=r(Y,{role:`activate:${this.name}`,props:{children:t,name:this.name},component:l});return this.activates.reduce(((e,t)=>{const n=t(this.name);return void 0!==n?r(i,{children:n}):e}),n)};return e=>{let{children:i}=e;return r(S,{store:o,children:r(O,{children:s(pe,{context:this.name,children:[r(ge,{}),r(De,{locale:t,messages:n,children:r(c,{children:i})})]})})})}}async loadMessages(e,t){return await this.plugins.reduce((async(t,n)=>{const o=ke(await t);return n.localize?Object.assign({},o,ke(await n.localize(e))):o}),t(e))}}async function Me(n,o,r,i,s,l){const c=await async function(n,o){let r=[];if(o){const t=e(o);try{r=await t.getInstalled(n),r=r.filter((e=>!window.TopWritePlugins[e.name]?.meta))}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),n=M.parse(window.location.search);if("dev"in n||e){const o=n.dev||e||8080;try{const e=(await t.get(`http://localhost:${o}/meta`)).data;r=r.filter((t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type))),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],r.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(o))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter((e=>{let[,t]=e;return!!t.meta})).map((e=>{let[,t]=e;return t.meta})),s=i.some((e=>"theme"===e.type)),l=Object.keys(window.TopWritePlugins),c=[];for(let e of r)e.disabled||l.includes(e.name)||s&&"theme"===e.type||c.push(ee(e));return await Promise.all(c),i.push(...r),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(o,l),a=new Pe(n,o,i);return a.registerModels(r),await a.registerPlugins(c),await a.createApp(s)}function Te(e){return D(e)}function ze(e){return $(e)}function Le(e){return[ze(e),Te(e)]}function Ie(e){const t=b(null),[n,o]=h(e);p((()=>{t.current&&(t.current(),t.current=null)}),[n]);return[n,(e,n)=>{t.current="function"==typeof n?n:null,o(e)}]}function je(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class Ae{constructor(e){let{name:t,meta:n,models:o={},components:r={},activate:i,register:s,localize:l,config:c}=e;k(this,"name",void 0),k(this,"config",void 0),k(this,"localize",void 0),k(this,"models",void 0),k(this,"components",void 0),k(this,"activate",void 0),k(this,"register",void 0),k(this,"meta",void 0),this.name=t,this.meta=n,this.models=o,this.components=r,this.activate=i,this.register=s,this.localize=l,this.config=c}}const Oe=B("root"),_e=B("element"),Ne=B("text");function We(e){return e.filter((e=>!(Ne(e)&&"\n"===e.value)))}function Ue(e,t,n){const o=t.properties,r=t.tagName,i={...o};n.prefix&&(n.key++,i.key=n.prefix+n.key);const s=[],l=We(t.children),c=l?l.length:0;let a=-1;for(;++a<c;){const t=l[a];_e(t)?s.push(Ue(e,t,n)):Ne(t)&&s.push(t.value)}return e.call(t,r,i,s.length>0?s:void 0)}function He(e,t){let{extensions:n=[],creator:o=l.createElement}=t;const r={allowDangerousHtml:!1,handlers:{...n.reduce(((e,t)=>Object.assign(e,t)),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},V(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},V(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let n=!1;for(const e of t.children)if(e.data?.directiveLabel){n=!0;break}return n||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},V(e,t))},heading(e,t){const n=e(t,"heading",V(e,t));return n.properties={...n.properties,depth:t.depth},n}},unknownHandler:()=>null},i=q(e,r);if(Oe(i))return We(i.children).map(((e,t)=>_e(e)?Ue(o,e,{key:0,prefix:`h-${t}-`}):Ne(e)?e.value:void 0));if(!_e(i))throw new Error("Expected root or element, not `"+(i&&i.type||i)+"`");return Ue(o,i,{key:0,prefix:"h-"})}const Ve=e=>{let{value:t}=e;return r("pre",{children:r("code",{children:t})})},qe=e=>{let{value:t}=e;return r("code",{children:t})};const Be=["video","audio"];function Fe(e){let{depth:t=5,...n}=e;return m(`h${t}`,n)}const Ge={"x-inline":function(e){const{name:t,value:n}=e;return r(Y,{role:`inline:${t}`,props:{type:"inline",name:t,value:n},component:qe})},"x-block":function(e){const{name:t,value:n,parameter:o}=e;return r(Y,{role:`block:${t}`,props:{type:"block",name:t,parameter:o,value:n},component:Ve})},textDirective:function(e){const{name:t,attributes:n,children:o,components:i={}}=e;let s=i[t],l=`html:${t}`;return customElements.get(`t-${t}`)?s=s||`t-${t}`:Be.includes(t)||(s=void 0,l=`directive:${t}`),r(Y,{role:l,props:{...n,children:o},component:s})},containerDirective:function(e){let{name:t,attributes:n,children:o,components:i={}}=e,s=i[t],l=`html:${t}`;const[c,...a]=v.toArray(o),d={children:a,label:c,...n};return customElements.get(`t-${t}`)?s=s||`t-${t}`:Be.includes(t)||(s=void 0,l=`directive:${t}`),r(Y,{role:l,props:d,component:s})},leafDirective:function(e){const{name:t,attributes:n,children:o,components:i={}}=e;let s=i[t],l=`html:${t}`;return customElements.get(`t-${t}`)?s=s||`t-${t}`:Be.includes(t)||(s=void 0,l=`directive:${t}`),r(Y,{role:l,props:{...n,children:o},component:s})},heading:function(e){let{components:t={},...n}=e;return r(Y,{role:"html:heading",props:n,component:t.heading||Fe})}},Re=e=>{let{tagName:t,components:n={},...o}=e;return Ge[t]?m(Ge[t],{...o,components:n}):F.includes(t)?r(Y,{role:`html:${t}`,props:o,component:n[t]||t}):(console.warn(`unknown tagName: ${t}`),null)};function Je(e){let{as:t=a,children:o,components:l={},aside:c=!0,header:d,footer:h,css:p,sectionAs:f,...g}=e;const w=u((()=>n().use(H).freeze()),[]),[b,v]=u((()=>{try{const e=w.data("toHastExtensions"),t=w.runSync(w.parse(o));let n=null;if(c){const o=U(t).map;o&&(n=He(o,{extensions:e}))}const r=He(t,{extensions:e,creator:(e,t,n)=>m(Re,{...t,tagName:e,components:l},n)});return[r,n]}catch(e){return console.log(e),[null,null]}}),[o,c,w]);return m(t,g,s(i,{children:[s("article",{children:[d,r(Ke,{$css:p,as:f,children:b}),h]}),v&&r("aside",{children:v})]}))}const Ke=I.section`
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  line-height: 1.2;
  word-wrap: break-word;

  & > *:first-child {
    margin-top: 0 !important;
  }

  & > *:last-child {
    margin-bottom: 0 !important;
  }

  h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
    margin: 1em 0;
    line-height: 1.2;
    padding: 0;

    &:last-child {
      margin-bottom: 0 !important;
    }

    &:first-child {
      margin-top: 0 !important;
    }
  }

  p {
    margin: 0;
    line-height: 2;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;

    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  h1 {
    font-size: 2em;
    line-height: 1.2;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: .5em;
  }

  h2 {
    padding-bottom: .4em;
    font-size: 1.3em;
    line-height: 1.2;
    border-bottom: 1px solid #eeeeee
  }

  h3 {
    font-size: 1.2em;
    line-height: 1.2;
  }

  h4 {
    font-size: 1.1em;
    line-height: 1.2;
  }

  h5 {
    font-size: 1em;
    line-height: 1.2;
  }

  hr {
    border: 0;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 0.5em;
  }

  ul {
    padding-left: 2em;

    ul {
      margin: 0;
    }
  }

  ol {
    padding-left: 2em;
  }

  li {
    line-height: 2;

    &.task-list-item {
      list-style: none;
      position: relative;

      input[type=checkbox] {
        position: absolute;
        left: -1.5em;
        top: 0.5em;
        width: 1em;
        height: 1em;
      }
    }

    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  code {
    display: inline-block;
    border-radius: 4px;
    padding: .2em .4em;
    background-color: #f7f7f7;
    word-break: break-all;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    white-space: pre;
    line-height: 1.3;
    color: inherit;
    font-size: inherit;
    margin: -.2em .4em;
  }

  pre {
    padding: 1.05em;
    overflow: auto;
    line-height: 1.45;
    background-color: #f7f7f7;
    border: 0;
    border-radius: 3px;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    font-size: inherit;
  }


  pre > code {
    display: inline;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow: initial;
    line-height: inherit;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    tab-size: 4;
  }

  p {
    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    line-height: 1.8;
    border-spacing: 0;

    th {
      text-align: left;

      &[align='center'] {
        text-align: center;
      }

      &[align='right'] {
        text-align: right;
      }
    }

    th, td {
      border: 1px solid #e0e0e0;
      padding: 3px 12px;
      height: 34px;
    }

    tr:hover td {
      background-color: #f1f1f1;
    }
  }

  img {
    max-width: 100%;
    display: inline-block;
    padding: 3px;
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    color: var(--ttw-primary-color);

    &:hover {
      text-decoration: underline;
    }
  }

  blockquote {
    padding: 5px 5px 5px 15px;
    color: #777777;
    border-left: 4px solid #dddddd;

    &.info {
      border-left-color: #5bc0de;
      color: #5bc0de;
      background-color: #f4f8fa;
    }

    &.warning {
      background-color: #fcf8f2;
      border-color: #f0ad4e;
      color: #f0ad4e;
    }

    &.danger {
      color: #d9534f;
      background-color: #fdf7f7;
      border-color: #d9534f;
    }

    &.success {
      background-color: #f3f8f3;
      border-color: #50af51;
      color: #50af51;
    }
  }

  video {
    display: block;
    width: 100%;
  }

  audio {
    display: block;
    width: 100%;
  }

  html[data-theme=dark] & {
    code {
      background-color: #333437;
    }

    pre {
      background-color: #333437;
    }

    h1, h2, hr {
      border-color: #404040;
    }

    th, td {
      border-color: #404040;
    }

    tr:hover td {
      background-color: #333437;
    }
  }

  ${e=>e.$css}
`;function Qe(e){let{root:t,children:n}=e;return G.createPortal(n,t)}const Xe=y(((e,t)=>{let{children:n}=e;const[o,i]=h(null);x(t,(()=>o),[o]);const s=f((e=>{if(e){const t=e.attachShadow({mode:"open"});i(t)}else i(null)}),[i]);return r("div",{ref:s,style:{all:"initial"},children:o&&r(A,{target:o,children:r(Qe,{root:o,children:n})})})}));function Ye(e){const t=b();return p((()=>{t.current=e}),[e]),t.current}function Ze(e){const t=b(e);p((()=>(document.title=e,()=>{document.title=t.current})),[e])}function et(e,t,n){const o=b(e),r=b(z(e,t,n));return p((()=>{o.current=e})),p((()=>{r.current=z((function(){o.current(...arguments)}),t,n)}),[t,n]),r.current}function tt(e,t,n){const o=b(e),r=b(L(e,t,n));return p((()=>{o.current=e})),p((()=>{r.current=L((function(){o.current(...arguments)}),t,n)}),[t,n]),r.current}function nt(){return $("options")}const ot=new EventTarget;function rt(){return ot}function it(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";const[n,o]=h((()=>window.localStorage.getItem(e)||t)),r=f((t=>{o(t),window.localStorage.setItem(e,t)}),[o,e]);p((()=>{const r=window.localStorage.getItem(e);n!==r&&o(r||t)}));const i=f((r=>{r.key===e&&r.newValue!==n&&o(r.newValue||t)}),[n]);return p((()=>(window.addEventListener("storage",i),()=>window.removeEventListener("storage",i))),[i]),[n,r]}function st(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.document;if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var lt=Object.freeze({__proto__:null,encode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function ct(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}const at="1.0.0";export{Y as InjectedComponent,Z as InjectedComponentSet,Ee as LocalizeProvider,Je as Markdown,Ae as Plugin,Xe as ShadowView,at as VERSION,lt as base64,Me as createApplication,te as createComponentDescriptor,ie as createStorageSlot,st as getPayload,je as getPublicPath,ct as isMac,se as listStorageKeys,Te as useActions,xe as useAsyncEffect,le as useBook,et as useDebounce,Ze as useDocumentTitle,rt as useEventTarget,Ce as useIntlContext,it as useLocalStorageState,Le as useModel,nt as useOptions,Ye as usePrevious,ze as useSelector,Ie as useStateWithCallback,ce as useThemeConfig,fe as useThemeContext,tt as useThrottle};
//# sourceMappingURL=index.js.map
